import { graphql } from "react-relay"

export const deDuplicatePatientsByPatientIdQuery = graphql`
  query deDuplicatePatientsByPatientIdQuery($patientId: ID!) {
    de_duplicatePatientsByPatientId(patientId: $patientId) {
      id
      firstName
      lastName
      gender
      displayId
    }
  }
`
